import { apiGet } from './http-client';

export type PublicBranchItem = {
  id: number;
  name: string;
  org_slug: string;
  org_name: string;
  organization_id: number;
  address: string | null;
  photo_url: string | null;
  working_hours: string | null;
  phone: string | null;
};

/** GET /api/v1/public/branches — филиалы платформы (без серверного фильтра по org); студия фильтруется по organization_id. */
export function fetchPublicBranches(): Promise<PublicBranchItem[]> {
  return apiGet<PublicBranchItem[]>('/api/v1/public/branches');
}
